module.exports = __webpack_public_path__ + "static/img/sample.d6306b4a.png";